module.exports = __webpack_public_path__ + "static/media/node.6dcf6999.png";